import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';
import { useCookieConsent } from '@/context';

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

export function GoogleAnalytics() {
  const location = useLocation();
  const { status } = useCookieConsent();

  // Initialize GA4 only if accepted and ID exists
  useEffect(() => {
    if (status === 'accepted' && GA_MEASUREMENT_ID) {
      ReactGA.initialize(GA_MEASUREMENT_ID);
    }
  }, [status]);

  // Track pageviews
  useEffect(() => {
    if (status === 'accepted' && GA_MEASUREMENT_ID) {
      ReactGA.send({
        hitType: 'pageview',
        page: location.pathname + location.search,
        title: document.title,
      });
    }
  }, [location, status]);

  return null;
}
